define('lq/visibility/defaultVisibility',[
    'jquery',
    'underscore'
], function ($, _) {
    'use strict';

    var DefaultVisibility = function () {
    };

    DefaultVisibility.prototype.apply = function (drop) {
        if (drop.data.initialVisibility === false)
            drop.hideWithoutAnimation();

        if (this.fromQuery(drop)) {
            drop.visibilityRegistrationId = drop.piping.datasources.registerDatasourceListener(
                drop.data.dataSourceForVisibility,
                function (data) {
                    var isVisible = data.Results.length && data.Results[0][drop.data.dataSourceOutputForVisibility];
                    if (isVisible === true)
                        drop.show();
                    else
                        drop.hide();
                }
            );
        } else if (this.fromParameter(drop)) {
            if (this.valueFromParameterIsTrue(drop))
                drop.showWithoutAnimation();
            else
                drop.hideWithoutAnimation();
        } else if (this.fromParentState(drop)) {
            drop.hideWithoutAnimation();

            _.each(drop.data.visibleWhenParentHasStates, function (state) {
                drop.getElementForVisibility().addClass("visible-when-" + state);
            });
        }
    };

    // note that this is a very naive implementation. It can use parameters that are passed in from another page,
    // but it won't be able to pick up parameters that are set during the PageLoad event or any other event.
    // If we need to support that second use case, we need to be able to listen to changes to parameter values
    DefaultVisibility.prototype.valueFromParameterIsTrue = function (drop) {
        var value = drop.piping.parameters.getValue(drop.data.parameterForVisibility);

        if ($.type(value) === 'boolean')
            return value === true;

        if ($.type(value) === 'string')
            return value.toLowerCase() === 'true';

        throw new Error('Cannot determine the visibility of the drop. The value of parameter ' + drop.data.parameterForVisibility + ' cannot be converted to a boolean.');
    };

    DefaultVisibility.prototype.fromQuery = function (drop) {
        return drop.data.initialVisibilityOption === 'From Query' && drop.data.dataSourceForVisibility;
    };

    DefaultVisibility.prototype.fromParameter = function (drop) {
        return drop.data.initialVisibilityOption === 'From Parameter' && drop.data.parameterForVisibility;
    };

    DefaultVisibility.prototype.fromParentState = function (drop) {
        return drop.data.initialVisibilityOption === 'FromParentState' && drop.data.visibleWhenParentHasStates;
    };
    
    return DefaultVisibility;
});
